import type { ListingBannersButton } from '@/shared/api/experience';
import { useI18n } from '@experience/i18n';
import ru from '../i18n/ru.json';

export function useDateTags() {
  const { t } = useI18n({
    inheritLocale: true,
    messages: {
      ru,
    },
  });

  const upcomingWeekendText = ref('');
  const upcomingWeekendParams = ref({
    start_date: '',
    end_date: '',
  });

  const formatDate = (offset = 0) => {
    const date = new Date();
    date.setDate(date.getDate() + offset);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const getUpcomingWeekendData = () => {
    const months = [
      t('bannerInjection.january'),
      t('bannerInjection.february'),
      t('bannerInjection.march'),
      t('bannerInjection.april'),
      t('bannerInjection.may'),
      t('bannerInjection.june'),
      t('bannerInjection.july'),
      t('bannerInjection.august'),
      t('bannerInjection.september'),
      t('bannerInjection.october'),
      t('bannerInjection.november'),
      t('bannerInjection.december'),
    ];

    const today = new Date();
    const dayOfWeek = today.getDay();
    const saturdayOffset = (6 - dayOfWeek) % 7;
    const saturday = new Date(today);
    saturday.setDate(today.getDate() + saturdayOffset);

    const sundayOffset = saturdayOffset + 1;
    const sunday = new Date(saturday);
    sunday.setDate(saturday.getDate() + 1);

    const dayStart = saturday.getDate();
    const dayEnd = sunday.getDate();
    const saturdayMonthName = months[saturday.getMonth()];
    const sundayMonthName = months[sunday.getMonth()];

    const isBothDatesInMonth = saturday.getMonth() === sunday.getMonth();
    upcomingWeekendText.value = isBothDatesInMonth
      ? `${t('bannerInjection.weekend')} ${dayStart}-${dayEnd} ${sundayMonthName}`
      : `${t('bannerInjection.weekend')}  ${dayStart} ${saturdayMonthName} - ${dayEnd} ${sundayMonthName}`;
    upcomingWeekendParams.value = {
      start_date: formatDate(saturdayOffset),
      end_date: formatDate(sundayOffset),
    };
  };
  getUpcomingWeekendData();

  const tags = computed<ListingBannersButton[]>(() => [
    {
      text: t('bannerInjection.today'),
      key: 'today',
      link: '',
      link_params: {
        start_date: formatDate(),
        end_date: formatDate(),
      },
    },
    {
      text: t('bannerInjection.tomorrow'),
      key: 'tomorrow',
      link: '',
      link_params: {
        start_date: formatDate(1),
        end_date: formatDate(1),
      },
    },
    {
      text: upcomingWeekendText.value,
      key: 'weekend',
      link: '',
      link_params: upcomingWeekendParams.value,
    },
  ]);

  return {
    tags,
  };
}
